import Checkbox from "../../../../../lib/components/checkbox/Checkbox";
import InputFieldGenerator from "./InputFieldGenerator";
import InputDateTimePicker from "../../inputFields/InputDateTimePicker";
import GF from "../../../../../lib/utils/GF";
import InputText from "../../inputFields/InputText";
import shortid from "shortid";
import BaseFieldGenerator from "./BaseFieldGenerator";
import React from "react";
import MenuItem from "../../menu/MenuItem";

class SimpleFilterFieldGenerator extends InputFieldGenerator {

  // Weiss statt der Standard-"primary"-Farbe, damit die Checkbox sich vom
  // gleichfarbigen (blauen) Hintergrund von Spaltenkopf/Filterzeile abhebt.
  static checkboxSx = {
    color: 'white',
    '&.Mui-checked': {color: 'white'},
    '&.MuiCheckbox-indeterminate': {color: 'white'}
  };

  constructor(onChange = null, inputLayout = 'inline', onDateTimePickerClose = null, size = 'medium') {
    super(onChange, inputLayout, size);
    if (onDateTimePickerClose === null) {
      onDateTimePickerClose = (e, id, value) => {
        // dummy
      }
    }
    this.onDateTimePickerCloseFunction = onDateTimePickerClose;
  }

  /**
   * Such-/Filterfelder sollen nicht wie Formularfelder validiert werden
   * (z.B. kein "Pflichtfeld"-Fehler bei leerem Filter).
   */
  computeConstrains(fieldType) {
    return [];
  }

  initBooleanField(id, fieldRef, fieldValue, fieldLabel, privilege) {
    let defaultValue;
    switch (typeof fieldValue) {
      case 'string':
        defaultValue = fieldValue.toLowerCase() === 'ja' || fieldValue.toLowerCase() === 'yes';
        break;
      default:
        defaultValue = fieldValue;
    }
    // Checkbox in weiss, da der Hintergrund (Spaltenkopf/Filterzeile) dieselbe Blau-Farbe wie
    // die Standard-Checkbox-Farbe (primary) hat und diese sonst im angehakten Zustand
    // unsichtbar wird.
    return <Checkbox _id={id} ref={fieldRef} checked={defaultValue} type='checkboxWithNoneState' labelElement={fieldLabel} onChange={(e, id, value) => this.onChange(
      e, id, value)} inputLayout={this.inputLayout} sx={SimpleFilterFieldGenerator.checkboxSx}/>;
  }

  initDateTimePickerField(id, fieldRef, fieldValue, fieldLabel, privilege, useTime) {
    // InputDateTimePicker kennt kein "onClose"-Prop (das wurde bisher nie aufgerufen,
    // weshalb eine Eingabe im Suchfeld wirkungslos blieb). Wie bei allen anderen
    // Feldern über "onChange" an handleSimpleSearchChange weiterreichen.
    return <InputDateTimePicker _id={id} ref={fieldRef} defaultValue={fieldValue} labelElement={fieldLabel} size={this.size}
      onChange={(e, id, value) => this.onChange(e, id, value)}
      inputLayout={this.inputLayout} useTime={useTime} canChooseUseTime={false}/>;
  }

  initEnumField(fieldType, id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    // Zusätzliche leere Option an erster Stelle, mit welcher das Feld nicht (mehr)
    // für die Suche verwendet wird. Sie ist standardmässig ausgewählt, solange kein
    // Filterwert gesetzt ist.
    const dropDown = super.initEnumField(fieldType, id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
    const emptyOption = <MenuItem key='simple-filter-empty' value=''>&nbsp;</MenuItem>;
    return React.cloneElement(dropDown, {}, emptyOption, ...React.Children.toArray(dropDown.props.children));
  }

  initLinkField(id, fieldRef, fieldValue, fieldLabel, privilege) {
    return this.initTextField(id, fieldRef, fieldValue, fieldLabel, privilege);
  }

  /**
   * Jede Eingabe im Suchfeld löst über Entity.handleSimpleSearchChange ein setState aus,
   * wodurch die Spaltenkopfzeile neu gerendert wird. Die Basisklasse vergibt dabei einen
   * neuen zufälligen Key (shortid()), was React dazu zwingt, das Textfeld bei jedem
   * Tastendruck komplett neu zu mounten - der Fokus geht verloren und es kommt nur der
   * erste eingegebene Buchstabe an. Mit einem auf der Feld-ID basierenden, stabilen Key
   * bleibt das DOM-Element über die Re-Renders hinweg erhalten, sodass ungestört
   * weitergeschrieben werden kann; die Suche selbst bleibt wie gewohnt um 500ms verzögert
   * (siehe Entity.handleSimpleSearchChange).
   */
  initTextField(id, fieldRef, fieldValue, fieldLabel, privilege, maxLength, constrains) {
    const field = super.initTextField(id, fieldRef, fieldValue, fieldLabel, privilege, maxLength, constrains);
    return React.cloneElement(field, {key: id});
  }

  initResourceField(id, fieldRef, fieldValue, fieldLabel, dtoProperties, privilege) {
    return <InputText _id={id} ref={fieldRef} key={shortid()} size={this.size} labelElement={fieldLabel} defaultValue={fieldValue} onChange={(e, id, value) => this.onChange(
      e, id, value)} inputLayout={this.inputLayout} state={BaseFieldGenerator.generateState(privilege)}/>;
  }

  onDateTimePickerClose(id, value) {
    if (GF.checkNotNull(this.onDateTimePickerCloseFunction)) {
      this.onDateTimePickerCloseFunction(id, value);
    }
  }
}

export default SimpleFilterFieldGenerator;
